import { useContext, useEffect, useState } from 'react'
import { useSceneStore } from '../../a.scenes/GameScene/store'
import { addEventListener, EVENTS_GAME } from '../../b.providers/EventsProvider/EventsProvider'
import { SEL_CURRENT_LEVEL_CONFIG } from '../../b.providers/ScenesProvider/selectors'
import { useScenesStore } from '../../b.providers/ScenesProvider/store'
import { SEL_BATTLE_STATE } from '../../c.managers/LevelManager/selectors'
import { BATTLE_STATES, COMMANDERS, Spell } from '../../c.managers/LevelManager/store.d'
import { SEL_LEVEL_SUMMARY, SEL_TREASURES } from '../../c.managers/TerrainManager/selectors'
import BaseWindow from './components/BaseWindow/BaseWindow'
import Overlay from './components/Overlay/Overlay'
import { NavContext, NavContextType, useNav } from './ScreensNav'

const LoadingScreen = () => {
  // { ctx }: { ctx: NavContextType }
  // const { dismiss, nav } = ctx
  const [progress, setProgress] = useState(0)
  useEffect(() => {
    const unsubProgress = addEventListener(
      EVENTS_GAME.LOADING_PROGRESS,
      (e) => {
        const { url, itemsLoaded, itemsTotal } = e.payload
        // console.log(itemsLoaded, itemsTotal);
        
        setProgress((itemsLoaded / itemsTotal) * 100)
      },
    )
    return () => {
      unsubProgress()
    }
  }, [])

  if(progress === 100) return null

  return (
    <Overlay show={true} transparent={true} className={`colored-background`}>
      <BaseWindow show>
        <div className={`body-container`}>
          <div className="header-container">
            <span>Loading...</span>
          </div>
          <div className="body-content">
            <div className="body-row no-bottom-line">
              <div style={{ width: '100%', backgroundColor: 'gray' }}>
                <div style={{ width: `${progress}%`, backgroundColor: 'green', height: 40}} />
              </div>
            </div>
            {/* <div className="body-row">
              <a
                className="body-row no-bottom-line"
                onClick={() => {
                  nav('/next')
                }}
              >
                <div className="theme-button button-orange-big">NEXT</div>
              </a>
            </div> */}
          </div>
        </div>
      </BaseWindow>
    </Overlay>
  )
}

export default LoadingScreen
